//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { getContentLibraryProcessingItems } from '@apis/content-library/contentLibraryApi';
import { wait } from '@utils/wait';

const TIMEOUT_MULTIPLIER = 3000;
const MAX_TIMEOUT = 30000;
const MAX_ITERATION_COUNT = 20;

export interface ProcessingConfig {
  isCancelled: boolean;
}

const recursivelyCheckIfAnyVideoProcessed = async (
  ids: string[],
  config: ProcessingConfig,
  iteration = 1,
) => {
  // we will try to check video processing status 20 times or return a failure
  if (config.isCancelled || iteration >= MAX_ITERATION_COUNT) {
    return false;
  }
  try {
    const processingItems = await getContentLibraryProcessingItems();

    if (ids.every((item) => processingItems.includes(item))) {
      await wait(Math.min(iteration * TIMEOUT_MULTIPLIER, MAX_TIMEOUT)); // Wait 3, 6, 9, 12 ... seconds

      return recursivelyCheckIfAnyVideoProcessed(ids, config, iteration + 1);
    } else {
      return true;
    }
  } catch (error) {
    await wait(Math.min(iteration * TIMEOUT_MULTIPLIER, MAX_TIMEOUT)); // Wait 3, 6, 9, 12 ... seconds

    return recursivelyCheckIfAnyVideoProcessed(ids, config, iteration + 1);
  }
};

// Check if any video is processed recursively.
export const checkIfAnyVideoProcessed = async (
  ids: string[],
  config: ProcessingConfig,
) => {
  return recursivelyCheckIfAnyVideoProcessed(ids, config);
};
